import React from 'react';
import { useTranslations } from 'next-intl';
import InputMask from 'react-input-mask';
import Input from '@/shared/ui/input';
import inputIcons from '@/shared/assets/sprites/inputs.sprite.svg';
interface Props {
  currentPhone: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
}
export const InputPhone: React.FC<Props> = props => {
  const {
    currentPhone,
    onChange,
    testId
  } = props;
  const t = useTranslations();
  return <label className="relative w-full" data-sentry-component="InputPhone" data-sentry-source-file="InputPhone.tsx">
      <div className="relative w-full">
        <InputMask mask="+7 (999) 999 99 99" value={currentPhone} onChange={onChange} data-sentry-element="InputMask" data-sentry-source-file="InputPhone.tsx">
          {(inputProps: React.InputHTMLAttributes<HTMLInputElement>) => <Input {...inputProps} placeholder={t('bookingPage.phone_number')} type="tel" className="w-full" variant="leftIcon" data-testid={testId}>
              <svg className="absolute left-4 top-1/2 size-6 -translate-y-1/2 opacity-50">
                <use xlinkHref={`${inputIcons}#phone`}></use>
              </svg>
            </Input>}
        </InputMask>
      </div>

      <span className="mt-1 inline-block px-1.5 text-sm text-textAdditional">{t('bookingPage.sms_proceed')}</span>
    </label>;
};